import { render } from "./CreateTradingDetail.vue?vue&type=template&id=14dd0588"
import script from "./CreateTradingDetail.vue?vue&type=script&lang=js"
export * from "./CreateTradingDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__